import React, { useState, useEffect, useRef } from 'react';
import '../styles/HomeWork.css';
import image1 from '../assets/image1.png';
import image2 from '../assets/image2.png';
import image3 from '../assets/image3.png';

const HomeWork = () => {
  const [activeTab, setActiveTab] = useState('Lead');
  const sectionRef = useRef(null);

  // Lead Data
  const leadData = [
    { title: 'Publish', text: 'Publish their route', img: image1 },
    { title: 'Pick', text: 'Pick the fare payer along his trip.', img: image2 },
    { title: 'Receive payment', text: 'Get payment from fare payer', img: image3 },
  ];

  // Fare Payer (FP) Data
  const fpData = [
    { title: 'Book', text: 'Book A Ride that lead published', img: image1 },
    { title: 'Check in', text: 'After Lead start ride onboard on the vehicle,Take a ride', img: image2 },
    { title: 'Pay', text: 'Pay the fare to lead', img: image3 },
  ];

  // Scroll Animation Effect
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = sectionRef.current.querySelectorAll('.animate-text');
    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <section className="home-work" ref={sectionRef}>
      {/* Heading */}
      <h2 className="home-work-heading animate-text">How it Works</h2>

      {/* Toggle Buttons */}
      <div className="toggle-buttons animate-text">
        <button
          className={activeTab === 'Lead' ? 'active' : ''}
          onClick={() => setActiveTab('Lead')}
        >
          Lead
        </button>
        <button
          className={activeTab === 'FP' ? 'active' : ''}
          onClick={() => setActiveTab('FP')}
        >
          Fare Payer
        </button>
      </div>

      {/* Centered Title Above Images */}
      <h3 className="section-title animate-text">{activeTab === 'Lead' ? 'Lead' : 'Fare Payer'}</h3>
      <br></br>

      {/* Content Switching Based on Active Tab */}
      <div className="home-work-content">
        {(activeTab === 'Lead' ? leadData : fpData).map((item, index) => (
          <div key={index} className="work-item animate-text">
            <div className="image-container">
              <img src={item.img} alt={item.title} />
            </div>
            <h3 className='title'>{item.title}</h3>
            <p className='txt'>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeWork;
